"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GitProxyBackEndGenerator;
var _isomorphicGit = _interopRequireDefault(require("isomorphic-git"));
var _web = _interopRequireDefault(require("isomorphic-git/http/web"));
var _lightningFs = _interopRequireDefault(require("@isomorphic-git/lightning-fs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const corsProxy = 'https://cors.isomorphic-git.org';
const dir = '/repo';
let singleton;
function determineRepositoryURL(backend) {
  const name = backend.name; // TOOD consolidate CmsConfig and Config
  if (name.startsWith('github')) {
    return `https://github.com/${backend.repo}.git`;
  } else if (name.startsWith('gitlab')) {
    return `https://gitlab.com/${backend.repo}.git`;
  } else if (name.startsWith('git-gateway')) {
    if (!backend.repo) {
      throw new Error("Repository URL mandatory for 'git-gateway' configuration (https://[...]/repoName.git)");
    }
    return backend.repo;
  }
  throw new Error("Can't determine repository URL");
}
function GitProxyBackEndGenerator(T) {
  class GitProxyBackend {
    constructor(config, options = {}) {
      _defineProperty(this, "backend", void 0);
      _defineProperty(this, "config", void 0);
      _defineProperty(this, "fs", void 0);
      _defineProperty(this, "pfs", void 0);
      _defineProperty(this, "repositoryUrl", void 0);
      _defineProperty(this, "repository", void 0);
      this.backend = new T(config, options);
      this.config = config;
      this.fs = new _lightningFs.default('decapfs');
      this.pfs = this.fs.promises;
      this.repositoryUrl = determineRepositoryURL(config.backend);
      if (!singleton) {
        singleton = this.getRepository();
      }
      this.repository = singleton;
    }
    async getRepository() {
      const branch = this.config.backend.branch || 'main';
      try {
        await this.pfs.stat(dir);
      } catch (e) {
        await this.pfs.mkdir(dir);
        await _isomorphicGit.default.init({
          fs: this.fs,
          dir,
          defaultBranch: branch
        });
      }
      await _isomorphicGit.default.addRemote({
        fs: this.fs,
        dir,
        url: this.repositoryUrl,
        remote: 'origin',
        force: true
      });
      await _isomorphicGit.default.fetch({
        fs: this.fs,
        http: _web.default,
        dir,
        corsProxy,
        remote: 'origin',
        ref: branch,
        singleBranch: true,
        depth: 1
      });
      await _isomorphicGit.default.checkout({
        fs: this.fs,
        dir,
        ref: branch,
        force: true,
        track: false
      });
      return this.pfs.readdir(dir);
    }
    isGitBackend() {
      return true;
    }
    async entriesByFolder(folder, extension) {
      try {
        await this.repository;
        const files = await this.pfs.readdir(`${dir}/${folder}`);
        const relevantFiles = files.filter(name => name.endsWith(extension));
        return Promise.all(relevantFiles.map(async filename => {
          const path = `${folder}/${filename}`;
          const fullPath = `${dir}/${path}`;
          const data = await this.pfs.readFile(fullPath, 'utf8');
          return {
            data,
            file: {
              path,
              id: path
            }
          };
        }));
      } catch {
        return [];
      }
    }
    async getEntry(path) {
      await this.repository;
      const data = await this.pfs.readFile(`${dir}/${path}`, 'utf8');
      return {
        file: {
          path,
          id: null
        },
        data
      };
    }
    status() {
      return this.backend.status();
    }
    authComponent() {
      return this.backend.authComponent();
    }
    restoreUser(user) {
      return this.backend.restoreUser(user);
    }
    authenticate(credentials) {
      return this.backend.authenticate(credentials);
    }
    logout() {
      return this.backend.logout();
    }
    getToken() {
      return this.backend.getToken();
    }
    traverseCursor(cursor, action) {
      return this.backend.traverseCursor(cursor, action);
    }
    entriesByFiles(files) {
      return this.backend.entriesByFiles(files);
    }
    unpublishedEntries() {
      return this.backend.unpublishedEntries();
    }
    unpublishedEntry(args) {
      return this.backend.unpublishedEntry(args);
    }
    unpublishedEntryDataFile(collection, slug, path, id) {
      return this.backend.unpublishedEntryDataFile(collection, slug, path, id);
    }
    unpublishedEntryMediaFile(collection, slug, path, id) {
      return this.backend.unpublishedEntryMediaFile(collection, slug, path, id);
    }
    deleteUnpublishedEntry(collection, slug) {
      return this.backend.deleteUnpublishedEntry(collection, slug);
    }
    persistEntry(entry, opts) {
      return this.backend.persistEntry(entry, opts);
    }
    updateUnpublishedEntryStatus(collection, slug, newStatus) {
      return this.backend.updateUnpublishedEntryStatus(collection, slug, newStatus);
    }
    publishUnpublishedEntry(collection, slug) {
      return this.backend.publishUnpublishedEntry(collection, slug);
    }
    getMedia(folder) {
      return this.backend.getMedia(folder);
    }
    getMediaFile(path) {
      return this.backend.getMediaFile(path);
    }
    persistMedia(file, opts) {
      return this.backend.persistMedia(file, opts);
    }
    deleteFiles(paths, commitMessage) {
      return this.backend.deleteFiles(paths, commitMessage);
    }
    getDeployPreview(collectionName, slug) {
      return this.backend.getDeployPreview(collectionName, slug);
    }
  }
  return GitProxyBackend;
}